import React from "react"

import type { AppTextProps } from "../Text"

import { AppText } from "../Text"

export type HelperTextProps = AppTextProps

export function HelperText(props: HelperTextProps) {
  return <AppText colorScheme={"secondary"} fontSize={"$sm"} {...props} />
}
